// extracted by mini-css-extract-plugin
module.exports = {"policyHightlighted":"meal_policy_policyHightlighted__1HXkQ"};